<template>
    <el-dialog title="查看附件" :visible.sync="showDialog" width="1000px" :close-on-click-modal="false">
        <el-carousel trigger="click" height="400px" indicator-position="none" :autoplay="false" ref="carousel" :initial-index="imgIndex" @change="imgChange">
            <el-carousel-item v-for="(item,index) in imageInfoList" :key="index" name="index">
                <a :href="item.imagePath" target="_blank">
                    <el-image
                            style="width: 100%; height: 100%"
                            :src="item.imagePath"
                            fit="contain"></el-image>
                </a>
            </el-carousel-item>
        </el-carousel>
        <div slot="footer" class="img-foot">
            <div v-for="(item,index) in imageInfoList" class="img-list" @click="imgSel(index)" :class="{'active': smallImg == index}">
                <el-image
                        style="width: 80px; height: 80px"
                        :src="item.imagePath"
                        fit="cover"></el-image>
            </div>
        </div>
    </el-dialog>
</template>
<script>
    import Vue from 'vue'
    import {
        Dialog,
        Carousel,
        CarouselItem,
        Image
    } from 'element-ui';
    Vue.use(Dialog)
    Vue.use(Carousel);
    Vue.use(CarouselItem);
    Vue.use(Image);

    export default {
        props: ['parentFileData'],//通过props实现父组件数据到子组件的传递
        data() {
            return {
                imageInfoList: [],

                // 查看附件
                showDialog:false,
                imgIndex:null,
                smallImg:null,
            }
        },
        methods:{
            // 查看附件
            setActiveItem:setActiveItem,
            imgChange:imgChange,
            viewImg:viewImg,
            imgSel:imgSel,
        },
        watch: {
            parentFileData: function(newVal,oldVal){
                this.imageInfoList = newVal;  //newVal即是parentFileData
                // console.log(newVal);//这里再感受下值拿到了没
            }
        },
    }

    // 查看附件
    function setActiveItem(index) {
        if (this.$refs.carousel) {
            this.$refs.carousel.setActiveItem(index);
        }
    }
    function imgChange(val){
        console.log(val);
        this.smallImg = val;
    }
    function viewImg(index){
        this.showDialog = true;
        this.setActiveItem(index);
        this.imgIndex = index;
        this.smallImg = index;
    }
    function imgSel(index){
        this.smallImg = index;
        this.setActiveItem(index);
    }
</script>
<style scoped>
    /*查看附件*/
    .img-foot{
        text-align: left;
    }
    .img-list{
        display: inline-block;
        border: 2px solid transparent;
        font-size: 0;
        margin-right: 5px;
        cursor: pointer;
    }
    .img-list.active{
        border: 2px solid #1ab3a6;
    }
</style>